import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthAccountForBusinessUsersError extends TmAuthError {}
